/* eslint-disable */
import React, { useCallback, useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import _ from "lodash";
import {
    EuiBasicTable,
    EuiFlexGroup,
    EuiFlexItem,
    EuiFieldSearch,
    EuiButton,
    EuiPageContentBody,
    EuiPageContentHeaderSection,
    EuiTitle,
    EuiPageContent,
    EuiPageContentHeader,
    EuiPage,
    EuiPageBody,
    EuiSpacer,
    EuiText,
    EuiShowFor,
} from "@elastic/eui";
import { useSelector } from "react-redux";
import moment from "moment";
import { capitalize } from "utils/stringUtils";
import AbstractFormContainer from "../AbstractForm/container";
import AbstractPreviewContainer from "../AbstractPreview/container";
import AbstractDropdown from "../AbstractFormField/fields/AbstractDropdown";
import { Link } from "react-router-dom";
import { authorizedActionsSelector, getUserRoles } from "modules/auth/slice";
import Thumbnail from "modules/shared/Thumbnail/Thumbnail";
import { mapResourceObjectToArray } from "utils/jsonApiUtils";
import checkAuthorization from "modules/auth/helpers/checkAuthorization";
import { isValidDate } from "utils/dateAndTime";
import { renderTripIds } from "modules/orders/configs/columns";
import EntityIcon from "../EntityIcon";
import { AbstractTableWrapper, TableHeaderWrapper } from "../../style";
import { useIntl } from "react-intl";
import { useHistory } from "react-router-dom";
import { useParams } from "react-router-dom";
import trackAnalytics from "trackAnalytics";
// import ClientProjectOptionsFilter from 'modules/clientProjects/components/clientProjectOptionsFilter'
import ModalComponent from "components/modal";
import AssignAdmins from "modules/organizationAssignees/components/AssignAdminsForm";
import Api from "lib/api";
import { getOrganizationAssigneeDetails } from "modules/organizationAssignees/api";
import OrganizationAssigneesOptionsFilter from "modules/organizationAssignees/components/organizationAssigneesOptionsFilter";
import { modulesWithCreator } from "modules/shared/entity/constants";
import DriverComponentModal from "modules/drivers/DriverComponentModal";
import CreateLocationSuccess from "modules/locations/components/CreateLocationSuccess";
import CreateLocationModal from "modules/locations/components/CreateLocationModal";
import EditDriverProfile from "modules/drivers/EditDriverProfile";
import CreateTruckModal from "modules/trucks/components/createTruckModal";
import CreateSupplierModal from "modules/suppliers/components/createSupplierModal";
import EditTruckModal from "modules/trucks/components/editTruckModal";
import EditSupplierModal from "modules/suppliers/components/editSupplierModal";
import LocationsFilter from "modules/locations/components/LocationsFilter";
import CreateContractModal from "modules/contracts/components/CreateContractModal";
import { ConfirmModalContent } from "styles/elements/main";
import NewLocationCategoryModal from "modules/locationCategories/components/NewLocationCategoryModal";
import EditLocationCategoryModal from "modules/locationCategories/components/EditLocationCategoryModal";
import DriverVerifyModal from "modules/drivers/DriverVerifyModal";
import VerifySupplierModal from "modules/suppliers/components/VerifySupplierModal";
import VerifyTruckModal from "modules/trucks/components/VerifyTruckModal";
import VerificationAlert from "components/VerificationAlert";
import { SuppliersFilters } from "modules/suppliers/components";
import { TrucksFilter } from "modules/trucks/components";
import { DriversFilters } from "modules/drivers/components";
import { convertAttrubutesToHumanReadableFormat } from "modules/clientProjects/mapDataToMixpanel";
import ProjectsFilters from "modules/clientProjects/components/ProjectsFilters";
import { userRoles } from "constants/userRoles";
import { updateProjectInfo } from "modules/clientProjects/api";
import { setMessage } from "modules/shared/notification/slice";

const TableHeaderFilters = styled.div`
    display: flex;
    align-items: center;
`;

const mapColumnsToDropdown = (cols) =>
    cols
        .filter((col) => col.field)
        .map((col) => ({ id: col.field, label: _.startCase(col.field) }));
function AbstractTable({
    data,
    includedData,
    includedFields,
    options,
    isLoading,
    onChange,
    pagination,
    sorting,
    searchQuery,
    onSearchQueryChange,
    reFetch,
    dispatch,
    destroyEntity,
    entityDefaultObject,
    projectOptions,
    setProjectOptions,
    isFromClient,
}) {

    console.log("Table data", options)

    // start the form *************************************
    const getCreatorIncludedType = (type) => {
        switch (type) {
            case "AdminUser":
                return "creators";
            case "User":
                return "users";
            case "Driver":
                return "drivers";
            default:
                return type;
        }
    };


    const attrs =
        options.entityName === "organizationAssignees"
            ? _.map(data, (d) => {
                let branchesData = [];
                d.attributes.branchIds.forEach((id) => {
                    Object.keys(includedData.branches).forEach((key, index) => {
                        if (includedData.branches[key].id === id) {
                            branchesData.push({
                                label: includedData.branches[key].attributes.nameEn,
                                value: includedData.branches[key].id,
                            });
                        }
                    });
                });
                return {
                    id: d.attributes.adminUser.id,
                    ...d.attributes.adminUser,
                    assigneeType: d.attributes.assigneeType,
                    adminId: d.id,
                    branches: branchesData,
                };
            })
            : modulesWithCreator.includes(options.entityName)
                    ? _.map(data, (d) => {
                      let creatorId = d.attributes.creatorId;
                      let creatorType = d.attributes.creatorType;
                      let creatorEmail;
                      let creatorIncludedType = getCreatorIncludedType(creatorType);
                      if (creatorType && includedData[creatorIncludedType]) {
                          Object.keys(includedData[creatorIncludedType]).forEach((key) => {
                              if (includedData[creatorIncludedType][key].id == creatorId) {
                                  creatorEmail =
                                      includedData[creatorIncludedType][key].attributes.email;
                              }
                          });
                      }
                      return {
                          id: d.id,
                          ...d.attributes,
                          creatorId,
                          creatorEmail,
                          creatorType,
                      };
                  })
                    : options.entityName === "projects"
                            ? _.map(data, (d) => {
                              let creatorId = d.attributes.creatorId;
                              let creatorType = d.attributes.creatorType;
                              let clientId = d.attributes.organizationId;
                              let creatorIncludedType = getCreatorIncludedType(creatorType);
                              let creatorEmail;
                              let clientName;
                              if (creatorType && includedData[creatorIncludedType]) {
                                  Object.keys(includedData[creatorIncludedType]).forEach((key) => {
                                      if (includedData[creatorIncludedType][key].id == creatorId) {
                                          creatorEmail =
                                              includedData[creatorIncludedType][key].attributes.email;
                                      }
                                  });
                              }
                              if (clientId && includedData["organizations"]) {
                                  Object.keys(includedData["organizations"]).forEach((key) => {
                                      if (includedData["organizations"][key].id == clientId) {
                                          clientName = includedData["organizations"][key].attributes.name;
                                      }
                                  });
                              }
                              return {
                                  id: d.id,
                                  ...d.attributes,
                                  creatorId,
                                  creatorEmail,
                                  creatorType,
                                  clientName,
                              };
                          })
                            : _.map(data, (d) => ({ id: d.id, ...d.attributes }));
    const isPendingVerifyIem = attrs.some((a) => a.qaStatus === "pending_verification");
    const [selectedEntity, setSelectedEntity] = useState();
    const [showForm, setShowForm] = useState(false);
    const getCurrentUserRoles = useSelector(getUserRoles());
    // *driver states
    const [showCreationModal, setShowCreationModal] = useState(false); // for open and close ModalComponent
    const [showEditModal, setShowEditModal] = useState(false); //* for show edit modal
    const [showDiscardModal, setShowDiscardModal] = useState(false);
    const [showVerifcationModal, setShowVerifcationModal] = useState(false); //for show verification modal
    const [showPreview, setShowPreview] = useState(false);
    const [entityInfo, setEntityInfo] = useState(null);
    const intl = useIntl();
    // Admin assignes state
    const [selectedAdmin, setSelectedAdmin] = useState(null);
    const [assignementType, setAssignementType] = useState(null);
    const [selectedBranches, setSelectedBranches] = useState([]);
    const [assigneesError, setAssigneesError] = useState("");
    const [isAssigneeEdit, setIsAssigneeEdit] = useState(false);
    const [editAssigneeId, setEditAssigneeId] = useState(null);
    const [showConfirmDeleteAdmin, setShowConfirmDeleteAdmin] = useState(false);
    const [deleteAdminContent, setDeleteAdminContent] = useState(null);
    // supplier states
    const [showSupplierConfirmation, setShowSupplierConfirmation] = useState(false);
    const [isSupplierDataChange, setIsSupplierDataChange] = useState(false);

    // Locations State
    const [isLocationEdit, setIsLocationEdit] = useState(false);
    const [isLocationPreview, setIsLocationPreview] = useState(false);
    const [selectedLocationData, setSelectedLocationData] = useState(null);
    const [createdLocationData, setCreatedLocationData] = useState(null);
    const [showlocationSuccessModal, setShowLocationSuccesModal] = useState(false);
    /****************************************************************************************/

    // truck states
    const [showTruckCreationConfirmation, setShowTruckCreationConfirmation] = useState(false);
    const [isTruckDataChange, setIsTruckDataChange] = useState(false);
    const [isSuppliersEntity, setIsSuppliersEntity] = useState(false);

    // contracts states
    const [ownerType, setOwnerType] = useState(null);

    //location categories
    const [isLocationCategoriesChange, setIsLocationCategoriesChange] = useState(false);
    const [locationCategoriesConfirmation, setLocationCategoriesConfirmation] = useState(false);

    const authorizedActions = useSelector(authorizedActionsSelector());
    const isAuthorizedToCreate = checkAuthorization(
        authorizedActions,
        options.entityName,
        "create"
    );
    const isAuthorizedToPreview = checkAuthorization(authorizedActions, options.entityName, "show");
    const isAuthorizedToEdit = checkAuthorization(authorizedActions, options.entityName, "update");
    const isAuthorizedToDelete = checkAuthorization(
        authorizedActions,
        options.entityName,
        "destroy"
    );
    const isAuthorizedToReview = checkAuthorization(
        authorizedActions,
        options.entityName,
        "review"
    );
    const isAuthorizedToAutomate =
        options.entityName === "projects" &&
        getCurrentUserRoles.some(
            (role) => role === userRoles.PROJECT_MANAGER || role === userRoles.SUPERADMIN
        );
    const [showPauseAutomationConfirmation, setShowPauseAutomationConfirmation] = useState(false);
    const [showRunAutomationConfirmation, setShowRunAutomationConfirmation] = useState(false);

    const AUTOMATION_STATUS_OFF = 0;
    const AUTOMATION_STATUS_PAUSED = 1;
    const AUTOMATION_STATUS_RUNNING = 2;

    const history = useHistory();
    const { id } = useParams();
    const isProfileEntity = !!options.profileFields;
    const [filterOptions, setFilterOptions] = useState([]);
    const [organizationAssigneesOptions, setOrganizationAssigneesOptions] = useState([
        { label: "Managerial", value: "Managerial" },
        { label: "On-ground Operations", value: "On-ground Operations" },
    ]);
    useEffect(() => {
        if (options.entityName === "organizationAssignees") {
            setFilterOptions(organizationAssigneesOptions);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [options.entityName]);

    useEffect(() => {
        setFilterOptions(projectOptions);
    }, [projectOptions]);
    // handelModalClose => for handeling the modal close
    const handelModalClose = () => {
        setShowCreationModal(false);
    };
    useEffect(() => {
        if (/^\/database\/suppliers\/(\d+)$/.test(history.location.pathname)) {
            setIsSuppliersEntity(true);
            setOwnerType("Supplier");
        }
        if (/^\/database\/drivers\/(\d+)$/.test(history.location.pathname)) {
            setOwnerType("Driver");
        }
    }, [history]);
    const handleEditModalClose = () => setShowEditModal(false);
    const renderSearch = () =>
        !options.tableOptions?.hideSearch && (
            <EuiFieldSearch
                placeholder="Search..."
                onSearch={onSearchQueryChange}
                defaultValue={searchQuery}
                fullWidth
            />
        );

    const getIncludedEntities = (selectedEntity) => {
        if (_.isNil(selectedEntity)) {
            return {};
        }
        if (includedFields.length === 0) {
            return null;
        }

        const entityWithIncluded = {};
        includedFields.forEach((field) => {
            const fieldName = !field.isMultiple ? `${field.entityName}s` : field.entityName;
            const includedEntityIds = selectedEntity[field.name];
            const includedEntitiesList = mapResourceObjectToArray(includedData[fieldName]);

            if (!includedEntitiesList.length || includedEntityIds === null) {
                return {};
            }

            const selectedIncludedEntities = _(includedEntitiesList)
                .keyBy("id")
                .at(includedEntityIds)
                .value();

            entityWithIncluded[field.entityName] = selectedIncludedEntities;
        });

        return entityWithIncluded;
    };

    const renderForm = () => {
        // handle create btn
        if (!showForm) {
            return;
        } else {
            if (options.entityName === "projects") {
                history.push({
                    pathname: `/database/clientProjects/create`,
                    state: { OrganizationId: id, clientId: id, entityName: options.entityName },
                });

                return;
            }
            return (
                <AbstractFormContainer
                    entityObject={selectedEntity || {}}
                    includedEntities={getIncludedEntities(selectedEntity) ?? selectedEntity}
                    options={options}
                    onFinish={() => {
                        setShowForm(false);
                        setSelectedEntity(null);
                        reFetch();
                    }}
                />
            );
        }
    };

    const renderPreview = () => {
        if (!showPreview) {
            return;
        } else {
            if (options.entityName === "projects") {
                const id = selectedEntity.id;
                const mixPanelData = {
                    projectId: selectedEntity?.id,
                    projectStatus: selectedEntity?.status,
                };
                trackAnalytics(
                    `View project profile clicks`,
                    convertAttrubutesToHumanReadableFormat(mixPanelData)
                );
                history.push({
                    pathname: `/clientProjects/${selectedEntity.id}`,
                    state: {
                        projectId: selectedEntity.id,
                        clientId: selectedEntity?.organizationId,
                        entityName: options.entityName,
                    },
                });
            }
            return (
                <AbstractPreviewContainer
                    entityObject={selectedEntity}
                    includedEntities={getIncludedEntities(selectedEntity) ?? selectedEntity}
                    options={options}
                    onFinish={() => {
                        setShowPreview(false);
                        setSelectedEntity(null);
                    }}
                />
            );
        }
    };

    const onEditing = (e) => {
        trackAnalytics(`${options.entityName}_home_screen_edit`);
        if (options.entityName === "organizationAssignees") {
            setSelectedAdmin({ label: e.email, value: e.id });
            e.assigneeType === "Managerial"
                ? setAssignementType({
                    value: "managerial",
                    label: "Managerial Assignee",
                })
                : setAssignementType({
                    value: "on_ground",
                    label: "On-ground Operations Assignee",
                });
            setSelectedBranches(e.branches);
            setEditAssigneeId(e.adminId);
            setIsAssigneeEdit(true);
            setShowCreationModal(true);
        } else {
            setSelectedEntity({ ...e, ...entityDefaultObject });
            setShowForm(true);
        }
        //* *this switch statemant for edit modal please add your entity name as a case here */
        switch (options?.entityName) {
            case "drivers":
            case "suppliers":
            case "trucks":
            case "locationCategories":
                setShowEditModal(true);
                setShowForm(false);
                break;
            case "locations":
                handleEditLocation(e);
                setShowForm(false);
                break;
            default:
                setShowForm(true);
        }
    };
    // * adding mixPanel

    const onPreviewing = async (e) => {
        trackAnalytics(`${options.entityName}_home_screen_preview`);
        if (options.entityName === "organizationAssignees") {
            const data = await getOrganizationAssigneeDetails(e.adminId);
            setSelectedEntity({
                ...e,
                ...(data?.entities?.branches && {
                    branches: Object.keys(data.entities.branches).map((key) => ({
                        label: data.entities.branches[key].attributes.nameEn,
                    })),
                }),
            });
        } else if (options.entityName === "locations") {
            handlePreviewLocation(e);
            return;
        } else {
            setSelectedEntity(e);
        }
        if (options.entityName === "drivers") {
            history.push(`/database/drivers/${e?.id}`);
        }
        if (options.entityName === "suppliers") {
            history.push(`/database/suppliers/${e?.id}`);
        }
        setShowPreview(true);
    };
    // * adding mixPanel

    const onDeleting = useCallback(
        async (e) => {
            trackAnalytics(`${options.entityName}_home_screen_delete`);
            if (options.entityName === "organizationAssignees") {
                setDeleteAdminContent({
                    email: e.email,
                    id: e.adminId,
                });
                setShowConfirmDeleteAdmin(true);
            } else {
                const answer = window.confirm("Are you sure you want to delete this?");
                if (answer) {
                    await dispatch(destroyEntity(options.entityName, e.id));
                }
                reFetch();
            }
        },
        [destroyEntity, dispatch, options.entityName, reFetch]
    );

    const handleDeleteAdminAssignee = async () => {
        await dispatch(destroyEntity("organizationAssignees", deleteAdminContent.id));
        reFetch();
        setShowConfirmDeleteAdmin(false);
    };

    const cancelDeleteAdmin = () => {
        setShowConfirmDeleteAdmin(false);
        setDeleteAdminContent(null);
    };
    const handleVerification = (e) => {
        trackAnalytics(`${options.entityName} verification clicks`, { qaStatus: e.qaStatus });
        setEntityInfo(e);
        setShowVerifcationModal(true);
    };

    const runAutomation = (e) => {
        setSelectedEntity(e);
        setShowRunAutomationConfirmation(true);
    };

    const pauseAutomation = (e) => {
        setSelectedEntity(e);
        setShowPauseAutomationConfirmation(true);
    };

    const updateProjectAutomation = async (id, automationStatus) => {
        const data = {
            data: {
                type: "projects",
                id: id,
                attributes: {
                    automationStatus: automationStatus,
                },
            },
        };

        try {
            await updateProjectInfo(id, data);
            window.location.reload();
        } catch (error) {
            dispatch(
                setMessage({
                    content: error,
                    title: error?.error,
                    isError: true,
                })
            );
        }
    };

    const handleCloseVerifcationModal = () => {
        setEntityInfo(null);
        setShowVerifcationModal(false);
    };
    const entityDefaultColumns = useMemo(
        () => {
            return options.columns(
                {
                    ...(options.entityName !== "projects" && {
                        editAction: isAuthorizedToEdit && onEditing,
                    }),
                    ...(options.entityName !== "projects" && {
                        deleteAction: isAuthorizedToDelete && onDeleting,
                    }),
                    previewAction: isAuthorizedToPreview && onPreviewing,
                    verificationAction: isAuthorizedToReview && handleVerification,
                    runAutomateAction: isAuthorizedToAutomate && runAutomation,
                    pauseAutomateAction: isAuthorizedToAutomate && pauseAutomation,
                },
                isProfileEntity ? options.displayName || options.entityName : null
            );
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [options.columns]
    );
    const handleAdminsAssigneesSubmit = () => {
        const branchesIds = [];
        selectedBranches.forEach((branch) => {
            branchesIds.push(branch.value);
        });
        const data = {
            data: {
                ...(isAssigneeEdit && { id: editAssigneeId }),
                type: "organizationAssignees",
                attributes: {
                    ...(!isAssigneeEdit && { organizationId: id }),
                    assigneeType: assignementType?.value,
                    ...(!isAssigneeEdit && { adminUserId: selectedAdmin?.value }),
                    ...(assignementType?.value === "on_ground" && {
                        branchIds: branchesIds,
                    }),
                },
            },
        };
        if (isAssigneeEdit) {
            Api.put(`/organization-assignees/${editAssigneeId}`, data)
                .then(() => {
                    setAssigneesError("");
                    handleCloseAssignAdminModal();
                    setIsAssigneeEdit(false);
                    reFetch();
                })
                .catch((err) => setAssigneesError(err.errors[0].title));
        } else {
            Api.post("/organization-assignees", data)
                .then(() => {
                    setAssigneesError("");
                    handleCloseAssignAdminModal();
                    reFetch();
                })
                .catch((err) => setAssigneesError(err.errors[0].title));
        }
    };

    const handleCloseAssignAdminModal = () => {
        setShowCreationModal(false);
        setSelectedAdmin(null);
        setAssignementType(null);
        setSelectedBranches([]);
        setAssigneesError("");
        setIsAssigneeEdit(false);
        setEditAssigneeId(null);
    };
    /** ******************************************Locations******************************************** */
    const onAddLocationSuccess = (newLocationData) => {
        if (!isLocationEdit) {
            setCreatedLocationData(newLocationData);
            setShowLocationSuccesModal(true);
        }
        setShowCreationModal(false);
        reFetch();
    };

    const handleEditLocation = (data) => {
        setIsLocationEdit(true);
        setSelectedLocationData({
            id: data.id,
            client: { value: data.organizationId, label: data.organizationName },
            locationName: "",
            googleLocationDetails: data.address,
            nameAr: data.nameAr,
            nameEn: data.nameEn,
            street: data.streetAndBuildingNumber,
            description: data.description,
            category: {
                value: data.locationCategoryId,
                label: data.locationCategoryName,
            },
            clientCode: data.clientIdentifierCode,
            tags: data.locationType === "both" ? ["pickup", "dropoff"] : [data.locationType],
            lat: data.latitude,
            lang: data.longitude,
            gov: data.governorateName,
            city: data.cityName,
            area: data.areaName,
        });
        setShowCreationModal(true);
    };

    const handlePreviewLocation = (data) => {
        setIsLocationPreview(true);
        setSelectedLocationData({
            id: data.id,
            client: { value: data.organizationId, label: data.organizationName },
            locationName: "",
            googleLocationDetails: data.address,
            nameAr: data.nameAr,
            nameEn: data.nameEn,
            street: data.streetAndBuildingNumber,
            description: data.description,
            category: {
                value: data.locationCategoryId,
                label: data.locationCategoryName,
            },
            clientCode: data.clientIdentifierCode,
            tags: data.locationType === "both" ? ["pickup", "dropoff"] : [data.locationType],
            lat: data.latitude,
            lang: data.longitude,
            gov: data.governorateName,
            city: data.cityName,
            area: data.areaName,
        });
        setShowCreationModal(true);
    };
    /** ***************************************************************************************************** */

    const handleCloseTruckModal = () => {
        if (isTruckDataChange) {
            setShowTruckCreationConfirmation(true);
        } else {
            setShowTruckCreationConfirmation(false);
            setShowCreationModal(false);
        }
    };

    const [selectedColumns, setSelectedColumns] = useState([...entityDefaultColumns]);
    useEffect(() => {
        setSelectedColumns([...entityDefaultColumns]);
    }, [entityDefaultColumns]);
    const mapDropdownToColumns = (selectedOptions) => {
        return[
        ...selectedOptions.map((option, i) => ({
            field: option.id,
            name: _.startCase(option.label),
            sortable: true,
            truncateText: true,
            render: selectedColumns[i].render? selectedColumns[i].render : (colValue) =>
                colValue ? (
                    Object.keys(colValue).findIndex((k) => k.toLocaleLowerCase() === "url") !==
                        -1 ? (
                        <Thumbnail
                            src={colValue.url}
                            url={colValue.url}
                            alt={option.label}
                        />
                    ) : option.id.toLocaleLowerCase() === "id" ? (
                        <Link
                            to={
                                isProfileEntity
                                    ? `/database/${options.displayName || options.entityName
                                    }/${colValue}`
                                    : ""
                            }
                        >
                            #{colValue}
                        </Link>
                    ) : option.id.toLocaleLowerCase() === "name" ? (
                        <b>{colValue}</b>
                    ) : isValidDate(colValue) ? (
                        <>{moment(colValue).format("DD MMM YYYY h:mm")}</>
                    ) : _.isArray(colValue) && option.id === "tripIds" ? (
                        renderTripIds(colValue)
                    ) : (
                        <>{`${colValue}`}</>
                    )
                ) : (
                    <>{`No ${_.startCase(option.label)}...`}</>
                ),
        })),
        _.find(entityDefaultColumns, { name: "Actions" }),
    ]};

    const RenderTable = (
        <>
            <EuiBasicTable
                items={attrs}
                loading={isLoading}
                sorting={sorting}
                pagination={pagination}
                rowHeader="id"
                columns={selectedColumns}
                onChange={onChange}
                hasActions
            />
            {renderForm()}
            {renderPreview()}
        </>
    );

    // * adding mixPanel

    // TODO FIX WITH SP
    const renderCreateButton = (title) => {

        if (options.entityName === "supplier_partner_projects") {
            return <EuiButton
                style={{ fontWeight: 700, marginLeft: 8 }}
                color="primary"
                iconType="plus"
                onClick={() => {
                    if (options?.entityName === "projects") {
                        trackAnalytics(`${getCurrentUserRoles}__create_new_project`);
                    } else {
                        trackAnalytics(`${options.entityName}_home_screen_create_new`);
                    }
                    switch (options?.entityName) {
                        case "drivers":
                        case "locations":
                        case "trucks":
                        case "suppliers":
                        case "locationCategories":
                        case "supplier_partner_projects":
                            setShowCreationModal(true);
                            break;
                        default:
                            setShowForm(true);
                    }
                }}
            >
                {title}
            </EuiButton>
        } else if (!options.tableOptions?.hideCreate &&
            isAuthorizedToCreate) {
            return <EuiButton
                style={{ fontWeight: 700, marginLeft: 8 }}
                color="primary"
                iconType="plus"
                onClick={() => {
                    if (options?.entityName === "projects") {
                        trackAnalytics(`${getCurrentUserRoles}__create_new_project`);
                    } else {
                        trackAnalytics(`${options.entityName}_home_screen_create_new`);
                    }
                    switch (options?.entityName) {
                        case "drivers":
                        case "locations":
                        case "trucks":
                        case "suppliers":
                        case "locationCategories":
                        case "supplier_partner_projects":
                            setShowCreationModal(true);
                            break;
                        default:
                            setShowForm(true);
                    }
                }}
            >
                {title}
            </EuiButton>
        }
    }


    const renderAssignAdminButton = (title) =>
        isAuthorizedToCreate && (
            <EuiButton
                style={{ fontWeight: 700, marginLeft: 8 }}
                color="primary"
                iconType="plus"
                onClick={() => {
                    setShowCreationModal(true);
                }}
            >
                {title}
            </EuiButton>
        );

    const renderContractsButton = (title) =>
        isAuthorizedToCreate && (
            <EuiButton
                style={{ fontWeight: 700, marginLeft: 8 }}
                color="primary"
                iconType="plus"
                onClick={() => {
                    setShowCreationModal(true);
                }}
            >
                {title}
            </EuiButton>
        );

    const renderExistingTruckButton = (title) =>
        isAuthorizedToCreate &&
        !includedData?.truckTypes && (
            <EuiButton
                style={{ fontWeight: 700, marginLeft: 8 }}
                color="primary"
                iconType="plus"
                onClick={() => {
                    setShowEditModal(true);
                }}
            >
                {title}
            </EuiButton>
        );

    const availableColumns = mapColumnsToDropdown(
        // TODO: define entity models
        attrs.length
            ? Object.keys(attrs[0]).map((col) => ({
                field: col,
            }))
            : []
    );
    const handleCloseSupplierModal = () => {
        if (isSupplierDataChange) {
            setShowSupplierConfirmation(true);
        } else {
            setShowSupplierConfirmation(false);
            setShowCreationModal(false);
        }
    };
    const handleCloseLocationCategoriesModal = () => {
        if (isLocationCategoriesChange) {
            setLocationCategoriesConfirmation(true);
        } else {
            setLocationCategoriesConfirmation(false);
            setShowCreationModal(false);
        }
    };

    return (
        <EuiPage>
            <EuiPageBody component="div">
                <EuiPageContent
                    hasShadow={!options.url}
                    paddingSize={options.url ? "none" : "m"}
                    borderRadius={options.url ? "none" : "m"}
                    color={options.url ? "transparent" : "plain"}
                >
                    <EuiPageContentHeader>
                        <EuiPageContentHeaderSection fullWidth>
                            <EuiTitle>
                                <EuiFlexGroup
                                    direction="row"
                                    alignItems="center"
                                    style={{ width: "100%" }}
                                    justifyContent="spaceBetween"
                                    responsive={false}
                                >
                                    <EuiFlexItem>
                                        <TableHeaderWrapper
                                            gutterSize="xs"
                                            alignItems="center"
                                            responsive={false}
                                        >
                                            <EuiFlexItem grow={false}>
                                                <EntityIcon entityName={options.entityName} />
                                            </EuiFlexItem>
                                            <EuiFlexItem grow={false}>
                                                <EuiText
                                                    size="s"
                                                    style={{ width: "max-content" }}
                                                >
                                                    <h2>
                                                        {capitalize(
                                                            intl.formatMessage({
                                                                id: `layout.${_.kebabCase(
                                                                    options.displayName ||
                                                                    options.entityName
                                                                )}`,
                                                            })
                                                        )}
                                                    </h2>
                                                </EuiText>
                                            </EuiFlexItem>
                                        </TableHeaderWrapper>
                                    </EuiFlexItem>
                                    {options.entityName !== "organizationAssignees" &&
                                        options.entityName !== "contracts" && (
                                            <EuiFlexItem>
                                                {renderCreateButton(
                                                    intl.formatMessage({ id: "action.create" })
                                                )}
                                            </EuiFlexItem>
                                        )}
                                    {options.entityName === "organizationAssignees" && (
                                        <EuiFlexItem>
                                            {renderAssignAdminButton(
                                                intl.formatMessage({ id: "action.assign" })
                                            )}
                                        </EuiFlexItem>
                                    )}
                                    {options.entityName === "contracts" && (
                                        <EuiFlexItem>
                                            {renderContractsButton("Add Contract")}
                                        </EuiFlexItem>
                                    )}
                                    {options.entityName === "trucks" &&
                                        /^\/database\/drivers\/(\d+)$/.test(
                                            history.location.pathname
                                        ) && (
                                            <EuiFlexItem>
                                                {renderExistingTruckButton("Link Existing Truck")}
                                            </EuiFlexItem>
                                        )}
                                </EuiFlexGroup>
                            </EuiTitle>
                        </EuiPageContentHeaderSection>
                        <EuiShowFor sizes={["xs", "s"]}>
                            <EuiSpacer size="m" />
                        </EuiShowFor>

                        <TableHeaderFilters>
                            {/* {options.entityName === 'projects' && (
                                <ClientProjectOptionsFilter
                                    projectOptions={filterOptions}
                                    setProjectOptions={setProjectOptions}
                                />
                            )} */}
                            {options.entityName === "organizationAssignees" && (
                                <OrganizationAssigneesOptionsFilter
                                    organizationAssigneesOptions={filterOptions}
                                    setOrganizationAssigneesOptions={setProjectOptions}
                                />
                            )}
                        </TableHeaderFilters>
                        {/* search bar */}
                        <EuiPageContentHeaderSection>
                            {options.entityName !== "locations" &&
                                options.entityName !== "trucks" &&
                                options.entityName !== "suppliers" &&
                                options.entityName !== "drivers" &&
                                renderSearch()}
                        </EuiPageContentHeaderSection>
                    </EuiPageContentHeader>
                    {(options.entityName === "locations" ||
                        options.entityName === "trucks" ||
                        options.entityName === "suppliers" ||
                        options.entityName === "drivers") && (
                        <EuiPageContentHeaderSection>{renderSearch()}</EuiPageContentHeaderSection>
                    )}
                    <EuiPageContentBody>
                        <EuiFlexGroup
                            alignItems="center"
                            wrap
                            gutterSize="m"
                            direction="column"
                        ></EuiFlexGroup>
                        <EuiSpacer></EuiSpacer>
                        {/* new filter dropdowns */}
                        {options.entityName === "locations" && (
                            <LocationsFilter
                                setLocationsFilterOptinos={setProjectOptions}
                                filterOptions={projectOptions}
                                isFromClient={isFromClient}
                            />
                        )}
                        {options.entityName === "suppliers" && (
                            <SuppliersFilters
                                setSuppliersFiltersOptinos={setProjectOptions}
                                filterOptions={projectOptions}
                            />
                        )}
                        {options.entityName === "trucks" && (
                            <TrucksFilter
                                setTrucksFilterOptinos={setProjectOptions}
                                filterOptions={projectOptions}
                            />
                        )}
                        {options.entityName === "drivers" && (
                            <DriversFilters
                                setDriversFilterOptions={setProjectOptions}
                                filterOptions={projectOptions}
                            />
                        )}
                        {options.entityName === "projects" && (
                            <ProjectsFilters
                                setProjectFilterOptions={setProjectOptions}
                                filterOptions={projectOptions}
                            />
                        )}
                        <EuiFlexGroup>
                            <EuiFlexItem>
                                <AbstractDropdown
                                    entityOptions={{}}
                                    onValueChange={(selectedOptions) => {
                                        setSelectedColumns(mapDropdownToColumns(selectedOptions));
                                    }}
                                    selectedOptions={mapColumnsToDropdown(selectedColumns)}
                                    options={availableColumns}
                                    multipleSelection
                                />
                            </EuiFlexItem>
                        </EuiFlexGroup>

                        <EuiSpacer></EuiSpacer>
                        <AbstractTableWrapper>{RenderTable}</AbstractTableWrapper>
                    </EuiPageContentBody>
                </EuiPageContent>
                {/* new logic */}
                {options.entityName === "drivers" && (
                    <DriverComponentModal
                        open={showCreationModal}
                        onClose={handelModalClose}
                    />
                )}
                {options.entityName === "drivers" && showEditModal && (
                    <EditDriverProfile
                        open={showEditModal}
                        driverId={selectedEntity?.id}
                        onClose={handleEditModalClose}
                        handleDiscardEdit={() => {
                            setShowDiscardModal(true);
                        }}
                    />
                )}
                {options.entityName === "drivers" &&
                    showVerifcationModal &&
                    entityInfo?.qaStatus === "pending_verification" && (
                        <DriverVerifyModal
                            open={showVerifcationModal}
                            driverId={entityInfo?.id}
                            onClose={handleCloseVerifcationModal}
                            driverStaus={entityInfo?.qaStatus}
                        />
                    )}
                {options.entityName === "drivers" &&
                    showVerifcationModal &&
                    entityInfo?.qaStatus !== "pending_verification" && (
                        <VerificationAlert
                            open={showVerifcationModal}
                            entityId={entityInfo?.id}
                            onClose={handleCloseVerifcationModal}
                            entityStatus={entityInfo?.qaStatus}
                            entityName="driver"
                        />
                    )}
                {options.entityName === "organizationAssignees" && (
                    <ModalComponent
                        open={showCreationModal}
                        onClose={handleCloseAssignAdminModal}
                        header={isAssigneeEdit ? "+Edit Admin Assignemnt" : "+ Assign Admins"}
                        submitBtnText="Assign"
                        submitBtn
                        disabled={
                            selectedAdmin === null ||
                            assignementType === null ||
                            (assignementType?.value === "on_ground" &&
                                selectedBranches.length === 0)
                        }
                        cancelBtn
                        isFooter
                        onSubmit={handleAdminsAssigneesSubmit}
                        borderedHeader
                    >
                        <AssignAdmins
                            id={id}
                            selectedAdmin={selectedAdmin}
                            setSelectedAdmin={setSelectedAdmin}
                            assignementType={assignementType}
                            setAssignementType={setAssignementType}
                            selectedBranches={selectedBranches}
                            setSelectedBranches={setSelectedBranches}
                            error={assigneesError}
                            disableAdminSelect={isAssigneeEdit}
                        />
                    </ModalComponent>
                )}
                {options.entityName === "organizationAssignees" && (
                    <ModalComponent
                        open={showConfirmDeleteAdmin}
                        onClose={cancelDeleteAdmin}
                        header="Remove User"
                        submitBtnText="Remove"
                        submitBtn
                        cancelBtn
                        isFooter
                        onSubmit={handleDeleteAdminAssignee}
                        borderedHeader
                    >
                        {deleteAdminContent && (
                            <ConfirmModalContent>
                                Are you sure that you want to remove{" "}
                                <span>“{deleteAdminContent.email}”</span>from this client?
                            </ConfirmModalContent>
                        )}
                    </ModalComponent>
                )}
                {options.entityName === "locations" && (
                    <CreateLocationModal
                        showCreateLocationModal={showCreationModal}
                        handleCloseModal={() => {
                            setShowCreationModal(false);
                            setIsLocationPreview(false);
                            isLocationEdit && setShowDiscardModal(true);
                        }}
                        isEdit={isLocationEdit}
                        onSwitchToEdit={() => {
                            setIsLocationEdit(true);
                            setIsLocationPreview(false);
                        }}
                        existingLocationData={selectedLocationData}
                        onSuccess={onAddLocationSuccess}
                        readOnly={isLocationPreview}
                    />
                )}
                {options.entityName === "locations" && (
                    <ModalComponent
                        open={showlocationSuccessModal}
                        onClose={() => {
                            setShowLocationSuccesModal(false);
                            setCreatedLocationData(null);
                        }}
                    >
                        <CreateLocationSuccess locationData={createdLocationData} />
                    </ModalComponent>
                )}
                {options.entityName === "locations" && (
                    <ModalComponent
                        header={"Leave “Edit Location” Page"}
                        open={showDiscardModal}
                        onClose={() => {
                            setShowDiscardModal(false);
                            setShowCreationModal(true);
                        }}
                        onSubmit={() => {
                            setShowDiscardModal(false);
                            setIsLocationEdit(false);
                            setSelectedLocationData(null);
                        }}
                        submitBtnText={"Leave"}
                        submitBtn
                        cancelBtn
                        isFooter
                    >
                        <ConfirmModalContent>
                            You have unsaved changes that will be lost if you leave the page.
                        </ConfirmModalContent>
                    </ModalComponent>
                )}
                {options.entityName === "trucks" && (
                    <CreateTruckModal
                        showTruckModal={showCreationModal}
                        handleCloseTruckModal={handleCloseTruckModal}
                        setIsTruckDataChange={setIsTruckDataChange}
                        setShowTruckModal={setShowCreationModal}
                    />
                )}
                {options.entityName === "suppliers" && (
                    <CreateSupplierModal
                        showSupplierModal={showCreationModal}
                        setShowSupplierModal={setShowCreationModal}
                        handleCloseSupplierModal={handleCloseSupplierModal}
                        setIsSupplierDataChange={setIsSupplierDataChange}
                    />
                )}
                {options.entityName === "suppliers" && (
                    <ModalComponent
                        header={'Leave "Create Supplier" Page'}
                        open={showSupplierConfirmation}
                        onClose={() => {
                            setShowCreationModal(true);
                            setShowSupplierConfirmation(false);
                        }}
                        onSubmit={() => {
                            setShowCreationModal(false);
                            setShowSupplierConfirmation(false);
                        }}
                        submitBtnText={"Leave"}
                        submitBtn
                        cancelBtn
                        isFooter
                    >
                        <ConfirmModalContent>
                            You have unsaved changes that will be lost if you leave the page.
                        </ConfirmModalContent>
                    </ModalComponent>
                )}
                {options.entityName === "trucks" &&
                    showEditModal &&
                    (/^\/database\/drivers\/(\d+)$/.test(history.location.pathname) ? (
                        <EditDriverProfile
                            open={showEditModal}
                            driverId={id}
                            onClose={handleEditModalClose}
                            handleDiscardEdit={() => {
                                setShowDiscardModal(true);
                            }}
                        />
                    ) : (
                        <EditTruckModal
                            showEditTruckModal={showEditModal}
                            selectedTruckId={selectedEntity?.id}
                            qaStatus={selectedEntity?.qaStatus}
                            handleCloseEditTruckModal={() => setShowDiscardModal(true)}
                            setShowEditTruckModal={setShowEditModal}
                            isSuppliersEntity={isSuppliersEntity}
                        ></EditTruckModal>
                    ))}
                {options.entityName === "trucks" && showDiscardModal && (
                    <ModalComponent
                        header={'Leave “Edit Truck" Page'}
                        open={showDiscardModal}
                        submitBtnText="Leave"
                        onSubmit={() => {
                            setShowEditModal(!showEditModal);
                            setShowDiscardModal(!showDiscardModal);
                        }}
                        onClose={() => setShowDiscardModal(!showDiscardModal)}
                        submitBtn
                        cancelBtn
                        isFooter
                    >
                        <ConfirmModalContent>
                            You have unsubmitted edits that will be lost if you leave the page.
                        </ConfirmModalContent>
                    </ModalComponent>
                )}
                {options.entityName === "trucks" && (
                    <ModalComponent
                        header={'Leave "Create Truck" Page'}
                        open={showTruckCreationConfirmation}
                        onClose={() => {
                            setShowCreationModal(true);
                            setShowTruckCreationConfirmation(false);
                        }}
                        onSubmit={() => {
                            setShowCreationModal(false);
                            setShowTruckCreationConfirmation(false);
                        }}
                        submitBtnText={"Leave"}
                        submitBtn
                        cancelBtn
                        isFooter
                    >
                        <ConfirmModalContent>
                            You have unsaved changes that will be lost if you leave the page.
                        </ConfirmModalContent>
                    </ModalComponent>
                )}
                {options.entityName === "trucks" &&
                    showVerifcationModal &&
                    entityInfo?.qaStatus === "pending_verification" && (
                        <VerifyTruckModal
                            open={showVerifcationModal}
                            onClose={handleCloseVerifcationModal}
                            truckStatus={entityInfo?.qaStatus}
                            truckrId={entityInfo?.id}
                        />
                    )}
                {options.entityName === "trucks" &&
                    showVerifcationModal &&
                    entityInfo?.qaStatus !== "pending_verification" && (
                        <VerificationAlert
                            open={showVerifcationModal}
                            onClose={handleCloseVerifcationModal}
                            entityStatus={entityInfo?.qaStatus}
                            entityId={entityInfo?.id}
                            entityName="truck"
                        />
                    )}
                {options.entityName === "suppliers" && selectedEntity?.id && (
                    <EditSupplierModal
                        showEditSupplierModal={showEditModal}
                        selectedSupplierId={selectedEntity?.id}
                        qaStatus={selectedEntity?.qaStatus}
                        setShowEditSupplierModal={setShowEditModal}
                        handleCloseEditSupplierModal={() => setShowDiscardModal(true)}
                    />
                )}
                {options.entityName === "suppliers" && showDiscardModal && (
                    <ModalComponent
                        header={'Leave "Edit Supplier" Page'}
                        open={showDiscardModal}
                        onClose={() => {
                            setShowEditModal(true);
                            setShowDiscardModal(false);
                        }}
                        onSubmit={() => {
                            setShowEditModal(false);
                            setShowDiscardModal(false);
                        }}
                        submitBtnText={"Leave"}
                        submitBtn
                        cancelBtn
                        isFooter
                    >
                        <ConfirmModalContent>
                            You have unsaved changes that will be lost if you leave the page.
                        </ConfirmModalContent>
                    </ModalComponent>
                )}
                {options.entityName === "suppliers" &&
                    showVerifcationModal &&
                    entityInfo?.qaStatus === "pending_verification" && (
                        <VerifySupplierModal
                            open={showVerifcationModal}
                            supplierId={entityInfo?.id}
                            onClose={handleCloseVerifcationModal}
                            supplierStatus={entityInfo?.qaStatus}
                        />
                    )}
                {options.entityName === "suppliers" &&
                    showVerifcationModal &&
                    entityInfo?.qaStatus !== "pending_verification" && (
                        <VerificationAlert
                            open={showVerifcationModal}
                            entityId={entityInfo?.id}
                            onClose={handleCloseVerifcationModal}
                            entityStatus={entityInfo?.qaStatus}
                            entityName="supplier"
                        />
                    )}

                {options.entityName === "locationCategories" && (
                    <NewLocationCategoryModal
                        showLocationCategoriesModal={showCreationModal}
                        handleCloseLocationCategoriesModal={handleCloseLocationCategoriesModal}
                        setShowLocationCategoriesModal={setShowCreationModal}
                        setIsLocationCategoriesChange={setIsLocationCategoriesChange}
                    />
                )}
                {options.entityName === "locationCategories" && (
                    <ModalComponent
                        header={'Leave "Create Location Category" Page'}
                        open={locationCategoriesConfirmation}
                        onClose={() => {
                            setShowCreationModal(true);
                            setLocationCategoriesConfirmation(false);
                        }}
                        onSubmit={() => {
                            setShowCreationModal(false);
                            setLocationCategoriesConfirmation(false);
                        }}
                        submitBtnText={"Leave"}
                        submitBtn
                        cancelBtn
                        isFooter
                    >
                        <ConfirmModalContent>
                            You have unsaved changes that will be lost if you leave the page.
                        </ConfirmModalContent>
                    </ModalComponent>
                )}
                {options.entityName === "locationCategories" && selectedEntity?.id && (
                    <EditLocationCategoryModal
                        showLocationCategoriesEditModal={showEditModal}
                        handleCloseLocationCategoriesEditModal={() => setShowDiscardModal(true)}
                        setShowLocationCategoriesEditModal={setShowEditModal}
                        selectedLocationCategoryData={selectedEntity}
                    />
                )}
                {options.entityName === "locationCategories" && showDiscardModal && (
                    <ModalComponent
                        header={'Leave "Edit Location Category" Page'}
                        open={showDiscardModal}
                        onClose={() => {
                            setShowEditModal(true);
                            setShowDiscardModal(false);
                        }}
                        onSubmit={() => {
                            setShowEditModal(false);
                            setShowDiscardModal(false);
                        }}
                        submitBtnText={"Leave"}
                        submitBtn
                        cancelBtn
                        isFooter
                    >
                        <ConfirmModalContent>
                            You have unsaved changes that will be lost if you leave the page.
                        </ConfirmModalContent>
                    </ModalComponent>
                )}

                {options.entityName === "contracts" && (
                    <CreateContractModal
                        showNewContractModal={showCreationModal}
                        handleCloseNewContractModal={() => setShowCreationModal(false)}
                        ownerId={id}
                        ownerType={ownerType}
                    />
                )}
                {options.entityName === "projects" && (
                    <ModalComponent
                        header={"Pause Project Automation"}
                        open={showPauseAutomationConfirmation}
                        onClose={() => {
                            setShowPauseAutomationConfirmation(false);
                        }}
                        onSubmit={() => {
                            updateProjectAutomation(selectedEntity?.id, AUTOMATION_STATUS_PAUSED);
                            setShowPauseAutomationConfirmation(false);
                        }}
                        submitBtnText={"Pause"}
                        submitBtn
                        cancelBtn
                        isFooter
                    >
                        <ConfirmModalContent>
                            Are you sure you want to pause project #{selectedEntity?.name} that
                            includes #{selectedEntity?.conditionsIds?.length} working condition, and
                            #{selectedEntity?.numberOfTrucks} trucks?
                        </ConfirmModalContent>
                    </ModalComponent>
                )}
                {options.entityName === "projects" && (
                    <ModalComponent
                        header={"Run Project Automation"}
                        open={showRunAutomationConfirmation}
                        onClose={() => {
                            setShowRunAutomationConfirmation(false);
                        }}
                        onSubmit={() => {
                            updateProjectAutomation(selectedEntity?.id, AUTOMATION_STATUS_RUNNING);
                            setShowRunAutomationConfirmation(false);
                        }}
                        submitBtnText={"Run"}
                        submitBtn
                        cancelBtn
                        isFooter
                    >
                        <ConfirmModalContent>
                            Are you sure you want to run project #{selectedEntity?.name} that
                            includes #{selectedEntity?.conditionsIds?.length} working condition, and
                            #{selectedEntity?.numberOfTrucks} trucks?
                        </ConfirmModalContent>
                    </ModalComponent>
                )}
            </EuiPageBody>
        </EuiPage>
    );
}

export default AbstractTable;
